import { SyncBadge } from './Sync';
import { Icon, type IconName } from './ui';

const MAIN: { path: string; label: string; icon: IconName }[] = [
  { path: '/', label: '홈', icon: 'home' },
  { path: '/train', label: '훈련', icon: 'bolt' },
  { path: '/review', label: '복습', icon: 'review' },
  { path: '/knowledge', label: '지식', icon: 'book' },
  { path: '/decisions', label: '판단', icon: 'target' },
  { path: '/stats', label: '분석', icon: 'chart' },
];
const EXTRA: { path: string; label: string; icon: IconName }[] = [
  { path: '/goals', label: '장기 목표', icon: 'flag' },
  { path: '/settings', label: '설정·데이터', icon: 'settings' },
];

const isActive = (current: string, path: string) => (path === '/' ? current === '/' : current === path || current.startsWith(`${path}/`));

function Brand() {
  return (
    <a className="brand" href="#/">
      <span className="brand-mark" aria-hidden="true">▲</span>APEX
    </a>
  );
}

export function Sidebar({ path }: { path: string }) {
  return (
    <nav className="sidebar" aria-label="주 메뉴">
      <Brand />
      <div className="nav">
        {MAIN.map((n) => (
          <a key={n.path} href={`#${n.path}`} className={isActive(path, n.path) ? 'active' : ''} aria-current={isActive(path, n.path) ? 'page' : undefined}>
            <Icon name={n.icon} />
            {n.label}
          </a>
        ))}
      </div>
      <div className="nav nav-extra">
        {EXTRA.map((n) => (
          <a key={n.path} href={`#${n.path}`} className={isActive(path, n.path) ? 'active' : ''}>
            <Icon name={n.icon} />
            {n.label}
          </a>
        ))}
      </div>
      <div className="sidebar-sync">
        <SyncBadge />
      </div>
    </nav>
  );
}

/** 폰 화면: 위쪽 막대(목표·설정) + 아래 탭 6개 */
export function TopBar({ path }: { path: string }) {
  return (
    <header className="topbar">
      <Brand />
      <SyncBadge compact />
      <div className="topbar-links">
        {EXTRA.map((n) => (
          <a key={n.path} href={`#${n.path}`} aria-label={n.label} className={isActive(path, n.path) ? 'active' : ''}>
            <Icon name={n.icon} />
          </a>
        ))}
      </div>
    </header>
  );
}

export function BottomNav({ path }: { path: string }) {
  return (
    <nav className="bottom-nav" aria-label="아래 메뉴">
      {MAIN.map((n) => (
        <a key={n.path} href={`#${n.path}`} className={isActive(path, n.path) ? 'active' : ''}>
          <Icon name={n.icon} size={22} />
          {n.label}
        </a>
      ))}
    </nav>
  );
}
